if (!Math.trunc) {
  Object.defineProperty(Math, "trunc", {
    value: function(val) {
      return val < 0 ? Math.ceil(val) : Math.floor(val);
    }
  });
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

function redirect(link) {
  window.location.replace(link);
}

function showCampaignData(data){
  const endTimestamp = $('[data-end-timestamp]').data('end-timestamp');
  if ( (new Date()).getTime() / 1000 < endTimestamp ) {
    $('[data-end-timestamp]').removeClass('hide');
  } else {
    $(".button--add-to-cart").hide();
  }
}

$(document).ready(function(){

  var end_date = $('[data-end-timestamp]').data('end-timestamp'); // $(".campaign_data").data('cmp_end_date');
  
  if(end_date == undefined){
    return;
  }
  var deadline = new Date(end_date * 1000).getTime(); 

  //var deadline = new Date(end_date).getTime(); 
  var x = setInterval(function() { 
    var now = new Date().getTime(); 
    var t = deadline - now; 
    var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
    var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
    var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
    var seconds = Math.floor((t % (1000 * 60)) / 1000); 


    $("#demo").html(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");

    // document.getElementById("demo").innerHTML = days + "d "  
    // + hours + "h " + minutes + "m " + seconds + "s "; 
    if (t < 0) { 
      clearInterval(x); 
      document.getElementById("demo").innerHTML = "EXPIRED";

    }else{
      $(".days_left_wrap .price-label").removeClass('hide');
    } 
  }, 1000); 

});
